// extracted by mini-css-extract-plugin
module.exports = {"container":"full-bleed-background_container__vF_UD"};